module.exports = __webpack_public_path__ + "static/media/file-download.62a8f62a.svg";